import { Drawer, Grid } from "@mui/material";
import { useEffect, useState } from "react";
import { ValidatorForm } from "react-material-ui-form-validator";
import { useNavigate, useParams } from "react-router-dom";
import { PrimaryButton } from "../../_components/button/primary.button";
import { DrawerHeader } from "../../_components/drawer/header.drawer";
import { TextValidatorHcs } from "../../_components/textValidator/textValidatorHcs";
import { toastr } from "../../_components/toastr/toastr";
import { handleErrorResponse } from "../../_helpers/handleResponse.helper";
import { userInformationNoteService } from "../../_services/userInformationNote.service";
import { useDrawerStyles } from "../../_styles/drawer.styles";
import { userOfficialNoteService } from "../../_services/userOfficialNote.service";

export const UserProfileOfficialNoteDrawer = (params: { emitOnSave(): void }) => {

    const resetData = () => ({
        id: 0,
        informationId: 0,
        note: "",
        noteTypeId: 2
    });

    const [data, setData] = useState<any>(resetData);
    const { userId, noteId } = useParams<{ userId: string, noteId: string }>();
    let navigate = useNavigate();

    useEffect(() => {
        if (noteId != null)
            fetchData();
        else
            setData(resetData);
    }, [noteId]);

    const [isLoading, setIsLoading] = useState(false);
    const [isSaving, setIsSaving] = useState(false);

    function fetchData() {
        if (!noteId) return;

        setIsLoading(true)
        return userOfficialNoteService
            .get(+(noteId || 0))
            .then(
                (json) => {
                    setData(json);
                }, handleErrorResponse
            )
            .finally(() => {
                setIsLoading(false);
            });
    }

    function submit(e: any) {
        e.preventDefault();
        setIsSaving(true);

        return userOfficialNoteService
            .submit({ ...data, userId: userId })
            .then(
                () => {
                    toastr.success("Saved successfully");
                    navigate("../");
                    params.emitOnSave();
                }, handleErrorResponse
            )
            .finally(() => setIsSaving(false));
    }

    function disable() {
        if (!noteId) return;
        setIsLoading(true);
        return userOfficialNoteService
            .disable(+(noteId || 0))
            .then(
                (d: any) => {
                    toastr.success("Disabled successfully");
                    fetchData();
                    navigate("../");
                    params.emitOnSave();
                }, handleErrorResponse
            )
            .finally(() => setIsLoading(false));
    }

    function handleChange(event: any) {
        setData((_data: any) => ({ ..._data, [event.target.name]: event.target.value }))
    };


    return (

        <Drawer
            anchor={"right"}
            variant="persistent"
            open={true}
            ModalProps={{
                keepMounted: true
            }}
        >

            <div
                tabIndex={0}
                role="button">

                <div>

                    <DrawerHeader name={(!!noteId) ? "Update Note" : "Create Note"} onClose={() => { navigate("../") }} />

                    <ValidatorForm
                        onSubmit={submit}
                        noValidate>

                        <Grid container spacing={1} sx={useDrawerStyles.container}>

                            <Grid item xs={12}>
                                <TextValidatorHcs
                                    key="note"
                                    name="note"
                                    label="Note"
                                    required
                                    fullWidth
                                    validators={['required', 'minStringLength:1']}
                                    errorMessages={['required field', "Field cannot be empty"]}
                                    value={data.note}
                                    onChange={handleChange}
                                />
                            </Grid>

                        </Grid>

                        <Grid container spacing={1} sx={useDrawerStyles.container}>

                            <Grid item xs={(data.id === 0 ? 12 : 6)}>
                                <PrimaryButton
                                    isSaving={isSaving}
                                    isLoading={isLoading}
                                    type="submit"
                                    variant="save">{"Save"}
                                </PrimaryButton>
                            </Grid>

                            {data.id > 0 &&
                                <Grid item xs={6}>
                                    <PrimaryButton
                                        type="button"
                                        variant="danger"
                                        disabled={isLoading}
                                        onClick={disable}
                                        icon="block"
                                    >
                                        Disable
                                    </PrimaryButton>
                                </Grid>
                            }

                        </Grid>

                    </ValidatorForm>
                </div>
            </div>
        </Drawer>
    );
};